import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_EVENT_PAGE_NAME } from '../../../constants/service/app/recommendEventConstants';
import RecommendEventDetailContainer from '../../../containers/recommend/event/RecommendEventDetailContainer';

const RecommendEventDetail = () => {
  return (
    <PageTemplate pageName={RECOMMEND_EVENT_PAGE_NAME.RECOMMEND_EVENT_DETAIL}>
      <RecommendEventDetailContainer />
    </PageTemplate>
  );
};

export default RecommendEventDetail;
